import * as React from "react";
const SvgSquare = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 12, height: 12, fill: "#E0E2EC" }));
export { SvgSquare as ReactComponent };
